import CorePageComponent from "../../components/CorePageComponent";
import SidebarComponent from "../../components/SidebarComponent";
import HeaderComponent from "../../components/HeaderComponent";
import  {useEffect, useState} from "react";
import { getTrips} from "../deliveries/services/apiService"
import { IonContent } from "@ionic/react";

function Dashboard () {

    const [pastDeliveries, setPastDeliveries] = useState({})

    useEffect(()=>{
        getPastTrips()
      },[])
    

    const getPastTrips = async () => {
        let pastTrips = await getTrips(1, 100, `5,6,7,8,9,10,40`)
        setPastDeliveries(pastTrips)
       }

    return (
        <>
        <IonContent className="dashboard-wrapper">
        <SidebarComponent activeMenu={['sidemenu-list', 'sidemenu-list active', 'sidemenu-list']}/>
        <HeaderComponent></HeaderComponent>
        <CorePageComponent countTrips={pastDeliveries.page && pastDeliveries.page.total} countDeliveries={pastDeliveries.page && pastDeliveries.page.total} totalAmt={pastDeliveries.result ? Math.round(pastDeliveries.result.reduce((partialSum, a) => partialSum + a.price, 0)) : 0} />
        </IonContent>
        </>
    )

}

export default Dashboard;